import {forwardRef, ReactNode, RefAttributes} from 'react'
import {ScrollAreaProps as RadixScrollAreaProps, ScrollAreaViewportProps} from '@radix-ui/react-scroll-area'
import {Scrollbar} from '@components/ui/scrollbar/Scrollbar.tsx'
import {StyledRoot, StyledViewport} from './style'
import {CSSProperties} from 'styled-components'

type ScrollAreaProps = {
    children: ReactNode
    scrollbar: ReturnType<typeof Scrollbar>
    viewportProps?: ScrollAreaViewportProps & RefAttributes<HTMLDivElement>
    overflowX?: CSSProperties['overflowX']
} & RadixScrollAreaProps

export const ScrollArea = forwardRef<HTMLDivElement, ScrollAreaProps>(
    ({children, scrollbar, viewportProps, overflowX, ...rest}, ref) => {
        return (
            <StyledRoot scrollHideDelay={500} ref={ref} $overflowX={overflowX} {...rest}>
                <StyledViewport {...viewportProps}>{children}</StyledViewport>
                {scrollbar}
            </StyledRoot>
        )
    }
)
